import { call, put, select, takeLatest } from 'redux-saga/effects';

import { quoteInformationActions } from '.';
import { getRequestPayload } from './utils';
import {
  selectErpSystem,
  selectLanguage,
} from 'app/features/erpSystem/slice/selectors';

import {
  selectSavedItem,
  selectSelectedItem,
} from 'app/features/selectedItem/slice/selectors';
import { selectSelectedFilters } from 'app/features/selectedFilters/slice/selectors';
import { QuoteResponse } from './types';
import { selectMetadataProdTimeAttr } from 'app/features/metadata/slice/selectors';

export function* fetchQuoteInformation() {
  const language = yield select(selectLanguage);
  const erpSystem = yield select(selectErpSystem);

  const savedItemValues = yield select(selectSelectedItem);
  const savedItemFilters = yield select(selectSelectedFilters);
  const metaDataProdTimeAttr = yield select(selectMetadataProdTimeAttr, {
    basicForm: savedItemFilters[1].filter.basicForm,
    valveType: savedItemFilters[1].filter.basicForm,
  });
  const selectedValve = yield select(state => selectSavedItem(state, 1));
  const selectedActuator = yield select(state => selectSavedItem(state, 2));
  const hasStemExtensions = selectedValve?.withStemExtension ? true : false;
  const hasSpeedControlBlock = selectedActuator?.withSpeedControlBlock
    ? true
    : false;
  const { getQuoteInformationSuccess, getQuoteInformationFail } =
    quoteInformationActions;
  let payload = getRequestPayload(
    erpSystem,
    language,
    savedItemValues,
    savedItemFilters,
    metaDataProdTimeAttr,
    hasStemExtensions,
    hasSpeedControlBlock,
  );
  try {
    const quoteInformationResp = yield call(
      fetch,
      '/valve-configurator/api/quoteInformation',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      },
    );
    if (quoteInformationResp.status !== 200) {
      return yield put(getQuoteInformationFail('Failed to fetch'));
    } else {
      const quoteResp: QuoteResponse = yield quoteInformationResp.json();
      if (quoteResp.productionTime === null) {
        return yield put(getQuoteInformationFail('Production time is null'));
      }
      return yield put(getQuoteInformationSuccess({ ...quoteResp }));
    }
  } catch (e) {}
}

export function* quoteInformationSaga() {
  yield takeLatest(
    quoteInformationActions.getQuoteInformationData.type,
    fetchQuoteInformation,
  );
}
